import React, { JSX } from "react";
import "../styles/Checkbox.scss";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";
type CheckboxProps = {
    id: string;
    label: JSX.Element | string;
    register: UseFormRegisterReturn;
    error?: FieldError;
    onChange?: () => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({ id, label, register, error, onChange }: CheckboxProps) => {
    return (
        <div className={`form-checkbox ${error ? "has-error" : ""}`}>
            <label htmlFor={id} className="checkbox-container">
                <input
                    id={id}
                    type="checkbox"
                    {...register}
                    onChange={(e) => {
                        register.onChange(e);
                        onChange?.();
                    }}
                />
                <span className="checkbox-input"></span>
                <span className="form-label">
                    {typeof label === "string" ? (
                        <span dangerouslySetInnerHTML={{ __html: label }} />
                    ) : (
                        label
                    )}
                </span>
            </label>
        </div>
    );
}